<template>
  <span
    ref="boxa"
    class="boxs"
  >
    <slot name="actionWidth" />
  </span>
</template>

<script setup lang="ts">
import { onActivated, onDeactivated, onMounted, onUnmounted, ref } from 'vue';

const emits = defineEmits<{
  (e: 'onWidth', width: number): void;
}>();
// 绑定包裹 slot 的父容器
const boxa = ref<HTMLElement | null>(null);
let resizeObserver: ResizeObserver | null = null;

const BtnWidth = ref(0);

// 初始化尺寸监听
const initWidthObserver = () => {
  if (!boxa.value) return;

  // 先断开旧监听，避免重复监听
  resizeObserver?.disconnect();
  // 创建ResizeObserver，监听父容器尺寸变化
  resizeObserver = new ResizeObserver(() => {
    // ✅ 这里拿到的是【所有按钮的总宽度】（和offsetWidth完全一致）
    if (BtnWidth.value == boxa.value.offsetWidth) {
      return;
    }
    BtnWidth.value = boxa.value.offsetWidth;
    setTimeout(() => {
      if (BtnWidth.value == boxa.value.offsetWidth) {
        emits('onWidth', BtnWidth.value);
      }
    }, 50);

    // 👇 你的业务逻辑写在这里：
    // 比如：把总宽度同步给其他元素、做自适应布局、存储宽度等
    // yourBusinessLogic(totalBtnWidth)
  });

  // 开始监听父容器
  const element = boxa.value;
  resizeObserver.observe(element);
  BtnWidth.value = element.offsetWidth;
  emits('onWidth', BtnWidth.value);
  // 初始挂载时，获取一次初始宽度
};

// 组件挂载时初始化监听
onMounted(() => {
  initWidthObserver();
});

// 如果组件用了<keep-alive>，激活时重新监听
onActivated(() => {
  initWidthObserver();
});

// 组件卸载/失活时，断开监听，防止内存泄漏
onUnmounted(() => {
  resizeObserver?.disconnect();
  resizeObserver = null;
});

onDeactivated(() => {
  resizeObserver?.disconnect();
});
</script>

<style lang="scss" scoped>
.boxs {
  // 关键样式：让父容器宽度自适应按钮内容
  opacity: 0;
  position: absolute;
}
</style>
